/**
 * Client Onboarding saga — V2 Faz E.
 *
 * Backend: Komut.Rentificial.Application/Controllers/Admin/Clients/
 *          ClientOnboardingController.cs  (`[Authorize(Roles = "admin")]`)
 */
import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";

import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { SagaActionParams, SagaGenericParams } from "src/request/types";

import { OnboardingDetail, OnboardingQueueResponse, OnboardingRisk } from "./type";

/** Onboarding kuyruğu. `params` örn: "?status=3&skip=0&take=25" */
export const getOnboardingQueue = createAction(
  "GET_CLIENT_ONBOARDING_QUEUE",
  ({ payload, params }: SagaActionParams<OnboardingQueueResponse>) => ({
    payload,
    url: "/api/admin/clientonboarding" + (params ?? ""),
  })
);

/** Tek başvurunun künyesi + belgeleri + anlık risk skoru. */
export const getOnboardingDetail = createAction(
  "GET_CLIENT_ONBOARDING_DETAIL",
  ({ payload, id }: SagaActionParams<OnboardingDetail>) => ({
    payload,
    url: "/api/admin/clientonboarding/" + id,
  })
);

/**
 * Durum geçişi. Backend durum makinesini uygular; geçersiz geçiş ve
 * gerekçesiz ret 400 döner.
 */
export const transitionOnboarding = createAction(
  "TRANSITION_CLIENT_ONBOARDING",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/clientonboarding/" + id + "/transition",
  })
);

export const approveOnboardingDocument = createAction(
  "APPROVE_CLIENT_ONBOARDING_DOCUMENT",
  ({ payload, id }: SagaActionParams<any>) => ({
    payload,
    body: {},
    url: "/api/admin/clientonboarding/documents/" + id + "/approve",
  })
);

export const rejectOnboardingDocument = createAction(
  "REJECT_CLIENT_ONBOARDING_DOCUMENT",
  ({ payload, id, body }: SagaActionParams<any>) => ({
    payload,
    body,
    url: "/api/admin/clientonboarding/documents/" + id + "/reject",
  })
);

/** Risk skorunu yeniden hesapla (belge onayı sonrası). */
export const recalcOnboardingRisk = createAction(
  "RECALC_CLIENT_ONBOARDING_RISK",
  ({ payload, id }: SagaActionParams<OnboardingRisk>) => ({
    payload,
    url: "/api/admin/clientonboarding/" + id + "/risk-score",
  })
);

const clientOnboardingSaga = [
  takeLatest<any>(getOnboardingQueue.toString(), (payload: SagaGenericParams<OnboardingQueueResponse>) =>
    getSaga<OnboardingQueueResponse>(payload)
  ),
  takeLatest<any>(getOnboardingDetail.toString(), (payload: SagaGenericParams<OnboardingDetail>) =>
    getSaga<OnboardingDetail>(payload)
  ),
  takeLatest<any>(recalcOnboardingRisk.toString(), (payload: SagaGenericParams<OnboardingRisk>) =>
    getSaga<OnboardingRisk>(payload)
  ),
  takeLatest<any>(transitionOnboarding.toString(), (payload: SagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
  takeLatest<any>(approveOnboardingDocument.toString(), (payload: SagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
  takeLatest<any>(rejectOnboardingDocument.toString(), (payload: SagaGenericParams<any>) =>
    postSaga<any>(payload)
  ),
];

export default clientOnboardingSaga;
